import {match} from 'ts-pattern';

import type {BulkOperationResponseBody} from '../../../types/api/bulkOperations';
import {isBulkOperationTerminal} from '../../../utils/isBulkOperationTerminal';

export type BulkOperationPanelSummary = {
  totalCount: number;
  runningCount: number;
  doneCount: number;
  errorCount: number;
};

/** Chip and panel header counts: done = finished clean, error = any failure, running = the rest. */
export function getBulkOperationPanelSummary(
  operations: BulkOperationResponseBody[]
): BulkOperationPanelSummary {
  const summary = {totalCount: operations.length, runningCount: 0, doneCount: 0, errorCount: 0};
  for (const operation of operations) {
    const key = match(operation)
      .when(
        (value) => !isBulkOperationTerminal(value.state),
        () => 'runningCount' as const
      )
      .with({state: 'FAILED'}, {state: 'RESOLVE_FAILED'}, () => 'errorCount' as const)
      .when(
        (value) => value.failedCount > 0,
        () => 'errorCount' as const
      )
      .otherwise(() => 'doneCount' as const);
    summary[key] += 1;
  }
  return summary;
}
